import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { removeCouponAction } from './actions'
import PromoBlock from './PromoBlock'
import withPromoModal from 'components/common/hoc/withPromoModal'

export default compose(
  connect(null, { removeCouponAction }),
  withPromoModal,
  withHandlers({
    removeCouponActionHandler: ({ removeCouponAction }) => couponCode => removeCouponAction({ couponCode })
  })
)(PromoBlock)

